module.exports = __webpack_public_path__ + "static/media/history-02.365c2398.png";